export default __webpack_public_path__ + "static/favicon-a217a711b32e53d3bae84362d3552904.ico";